/** 少数点以下第二位までの数値のバリデーションの正規表現 */
export const DECIMAL_VALIDATION = /^([1-9][0-9]{0,}|0)(\.[0-9]{1,2})?$/;

export const CATEGORY_PARENT_SITE_PROCESS = '1';
export const CATEGORY_CHILD_SITE_PROCESS = '2';

// fullcalendarで表示する期間の最大（年）。この値を超えるとスマートフォンなどで処理が重くなり画面がフリーズする
export const GANTT_DISPLAY_MAX_YEAR = 1;

export const validationMessage = {
  required: '必須です',
  decimal: '小数点以下第二位までの数値を入力してください',
  maxLength: (maxLength: number) => {
    return `${maxLength}文字以内で入力してください`;
  },
  max: (max: number) => {
    return `${max}以下の値を入力してください`;
  },
  min: (min: number) => {
    return `${min}以上の値を入力してください`;
  },
  dateFrom: '本日以降の日付になるように入力してください',
  dateFromTo: '開始日が終了日以前の日付になるように入力してください',
  ganttSearchPeriod: `検索期間は${GANTT_DISPLAY_MAX_YEAR}年以内になるように入力してください`
};

export const SITE_PROCESS_DISPLAY_MODE = {
  list: 1,
  gantt: 2
};

export const SITE_TASK_ORDER_TYPE = {
  outsources: '1',
  merchandise: '2'
};

export const SITE_PROCESS_DISPLAY_LIMIT_LIST = [10, 30, 50];

export const GANTT_MINIMUM_HEIGHT = 300;
export const GANTT_FULL_CALENDAR_CLASS_NAME_OPEN_SITE_PROCESS =
  '.fc-icon.fc-icon-plus-square';
export const GANTT_FULL_CALENDAR_CLASS_NAME_CLOSE_SITE_PROCESS =
  '.fc-icon.fc-icon-minus-square';

// ガントチャートのサイズ計算用
// 最低限の高さ
export const GANTT_ORDER_ZERO_FILL_LENGTH = 20;
// ガントチャートの左側のresourceエリアの幅
// ProcessGanttChart/style.cssから計算
export const GANTT_RESOURCE_ALL_WIDTH = 770;
export const GANTT_RESOURCE_TITLE_AND_ADD_BUTTON_WIDTH = 285;
export const GANTT_CALENDAR_RESOURCE_WIDTH = 480;
// 下記は操作感によって適当に設定
export const GANTT_RESOURCE_MIN_WIDTH_RATIO = 0.25; // ガントチャート全体での最低幅
export const GANTT_RESOURCE_ALL_WIDTH_RESPONSIVE_RATIO = 0.7; // レスポンシブ時のガントチャート全体での幅
// スマートフォンと判定する幅
export const GANTT_WINDOW_WIDTH_SMARTPHONE = 500;
// htmlのid
export const GANTT_CHART_HTML_ID = 'ganttchart';
export const GANTT_SEARCH_HTML_ID = 'searchContainer';

/** 工程履歴の検索用項目 */
export const SITE_PROCESS_ITEM_LIST = [
  {
    value: 1,
    label: '大工程'
  },
  {
    value: 2,
    label: '工程名'
  },
  {
    value: 3,
    label: '担当者'
  },
  {
    value: 4,
    label: '期間'
  },
  {
    value: 5,
    label: '計画人工'
  },
  {
    value: 6,
    label: '実働人工'
  },
  {
    value: 7,
    label: '備考'
  },
  {
    value: 8,
    label: 'ステータス'
  }
];
